var Preconditions = require('./Preconditions.js');
var _ = require('lodash');
var Time = require('./time.js'); 
var Avatar = require('./Avatar.js');
var BlobMetaData = require('./BlobMetaData.js');
var E164 = require('./E164.js');

function Message(json)
{
    this.data = _.cloneDeep(json);
}

Message.prototype.getId = function() { return this.data.message_id; }
Message.prototype.getMessageId = function() { return this.data.message_id; }
Message.prototype.getOrganizationAccountId = function() { return this.data.organization_id; }
Message.prototype.getOrganizationId = function() { return this.data.organization_id; }
Message.prototype.getConversationId = function() { return this.data.conversation_id; }
Message.prototype.getAuthor = function() { return this.data.author; }
Message.prototype.getTime = function() { return this.data.time; }
Message.prototype.getContentType = function() { return this.data.content_type; }
Message.prototype.getImageCaption = function () { return this.data.image_caption; }

Message.prototype.isSystemMessage = function() {
    if (this.getContentType() == null) return false;

    return this.getContentType() != null && this.getContentType().includes('application/redchirp-system-message');
}

Message.prototype.getContent = function() { return this.data.content; }
Message.prototype.getContentAsObject = function() { return JSON.parse(this.data.content); }


Message.prototype.isText = function() { return this.getContentType() === 'text/plain'; }
Message.prototype.isLongPlainText = function() { return this.getContentType() === 'application/redchirp-long-plain-text'; }
Message.prototype.isImage = function() { return this.getContentType() === 'application/redchirp-image'; }
Message.prototype.isFile = function() { return this.getContentType() === 'application/redchirp-file'; }
Message.prototype.isBlob = function() { return this.isImage() || this.isFile(); }
Message.prototype.isContactRequest = function() { return this.getContentType() === 'application/redchirp-contact-request-stored-message'; }
Message.prototype.isVoiceCallMetaData = function() { return this.getContentType() === 'application/redchirp-voice-call-meta-data'; }
Message.prototype.isVideoCallMetaData = function() { return this.getContentType() === 'application/redchirp-video-call-meta-data'; }
Message.prototype.isPaymentMessage = function() { return this.getContentType() === 'application/redchirp-payment-message'; }
Message.prototype.isAdfSendConversationMessage = function() { return this.getContentType() === 'application/redchirp-adf-send-conversation'; }
Message.prototype.isBulkMessageOptEvent = function() { return this.getContentType() === 'application/redchirp-bulk-message-opt-event'; }
Message.prototype.isArchiveConversationMessage = function() { return this.getContentType() === 'application/redchirp-system-message-archive'; }
Message.prototype.isRedChirpSystemMessage = function() { return this.getContentType() === 'application/redchirp-system-message'; }
Message.prototype.isClaimConversationMessage = function() { return this.getContentType() === 'application/redchirp-system-message-claim'; }
Message.prototype.isBulkMessageSetOutcome = function() { return this.getContentType() === 'application/redchirp-system-message-set-outcome'; }
Message.prototype.isVoicemailMetaData = function() { return this.getContentType() === 'application/redchirp-voicemail'; }
Message.prototype.isVCardMessage = function() { return this.getContentType() === 'text/x-vcard'; }
Message.prototype.isConsentAgreementMessage = function() { return this.getContentType() === 'application/redchirp-consent-agreement-message'; }
Message.prototype.isRedChirpVCardMessage = function() { return this.getContentType() === 'application/redchirp-vcard'; }
Message.prototype.isRedChirpTagsChangedMessage = function() { return this.getContentType() === 'application/redchirp-tags-changed'; }
Message.prototype.isNote = function() { return this.getContentType() === 'application/redchirp-note'; }
Message.prototype.isScheduledMessage = function() { return this.getContentType() === 'application/redchirp-scheduled-message'; }


Message.prototype.isBulkMessage = function() { return this.data.bulk_message_recipient_id !== null; }
Message.prototype.getState = function() { return this.data.state; }
Message.prototype.getStateDetail = function() { return this.data.state_detail; }
Message.prototype.getErrorCodeDesc = function() { return this.data.error_code_desc; }

Message.prototype.getBlobMetaData = function() 
{ 
    if ( !this.isBlob() ) 
        return null;

    return new BlobMetaData(JSON.parse(this.getContent()));
}

Message.prototype.getAuthorAvatar = function()
{
    let color_hash = this.getAuthor();
    
    if ( this.data.authored_by_employee_id != null )
        color_hash = this.data.authored_by_employee_id;
    
    return new Avatar(this.getLabelAuthor(), color_hash);
}

Message.prototype.getHumanReadableAge = function(now)
{
    return Time.getHumanReadableAge(this.getTime());
}

Message.prototype.getLabelAuthor = function(you_endpoint)
{
    if (E164.isUSPhoneNumber(E164.slimEndpoint(this.data.author_label)) || E164.isUSPhoneNumber(this.data.author_label))
    {
        return E164.prettyPrintUsPhoneNumber(this.data.author_label);
    }

    return this.data.author_label;
}

Message.prototype.getFileIcon = function()
{
    if ( !this.isFile() )
        return "mdi-file-outline";

    return this.getBlobMetaData().getFileIcon();
}

/*
{
    "message_id" : "28803e62-3855-4112-9697-4ffbcf75ad01",
    "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
    "conversation_id" : "c250dbda-b0d9-4c65-b7b4-915b8036ef0b",
    "author" : "E164:+16022231449",
    "time" : 1590078963500,
    "content_type" : "text/plain",
    "content" : "Perfect!"
}
*/

module.exports = Message;